import { createContext } from 'react';
const ClosureInformationContext = createContext();
export default ClosureInformationContext;
